import type {IconName} from '@vio/atlas/Icon'

export const RANKED_AMENITIES: {
  id: string
  icon: IconName
}[][] = [
  // Tier 1 — recreational (Pick top 2)
  [
    {id: '68', icon: 'Sunrise2'}, // Bay View
    {id: '71', icon: 'Sunrise2'}, // Beach View
    {id: '103', icon: 'Sunrise2'}, // Canyon View
    {id: '128', icon: 'Sunrise2'}, // City View
    {id: '153', icon: 'Trees'}, // Countryside View
    {id: '154', icon: 'Trees'}, // Courtyard View
    {id: '167', icon: 'Sunrise2'}, // Desert View
    {id: '256', icon: 'Trees'}, // Garden View
    {id: '258', icon: 'Golf'}, // Golf Course View
    {id: '274', icon: 'Boat'}, // Harbor View
    {id: '327', icon: 'Sunrise2'}, // Lake View
    {id: '328', icon: 'Sunrise2'}, // Lake/River View
    {id: '381', icon: 'Mountain'}, // Mountain View
    {id: '418', icon: 'Trees'}, // Park View
    {id: '436', icon: 'SwimmingPoolLadder'}, // Pool View
    {id: '476', icon: 'Sunrise2'}, // River View
    {id: '494', icon: 'Sunrise2'}, // Sea View
    {id: '607', icon: 'Mountain'}, // Valley View
    {id: '616', icon: 'Volcano'}, // Volcano View
    {id: '342', icon: 'Sunrise2'}, // Limited Sea View
    {id: '461', icon: 'Buildings'}, // Quiet Street View
    {id: '41', icon: 'Patio'}, // Balcony
    {id: '42', icon: 'Patio'}, // Balcony or Patio
    {id: '43', icon: 'Patio'}, // Balcony or Terrace
    {id: '233', icon: 'Patio'}, // French Balcony
    {id: '500', icon: 'Patio'}, // Deck or Patio
    {id: '165', icon: 'Patio'}, // Patio
    {id: '255', icon: 'Patio'}, // Terrace
    {id: '505', icon: 'Users'}, // Shared Accommodations
    {id: '21', icon: 'User'} // Adults Only
  ],
  // Tier 2 — basic comfort (Pick top 3)
  [
    {id: '22', icon: 'Ice'}, // Air Conditioning
    {id: '276', icon: 'Temperature'}, // Heated Floor
    {id: '278', icon: 'Temperature'}, // Heating
    {id: '604', icon: 'Temperature'}, // Underfloor Heating
    {id: '634', icon: 'Wifi'}, // Wi-Fi
    {id: '637', icon: 'Wifi'}, // Wi-Fi (Free)
    {id: '479', icon: 'Bed'}, // Rollaway or Extra Beds (Free)
    {id: '321', icon: 'Kitchen'}, // Kitchen
    {id: '325', icon: 'Kitchen'}, // Kitchenette
    {id: '142', icon: 'Kitchen'}, // Communal Kitchen
    {id: '501', icon: 'SofaBed'}, // Separate Living Room
    {id: '506', icon: 'Shower'}, // Shared Bathroom
    {id: '509', icon: 'Shower'}, // Shared Outdoor Bathroom
    {id: '446', icon: 'Shower'}, // Private Bathroom (Not in Room)
    {id: '487', icon: 'Safe'}, // Safety Deposit Box
    {id: '62', icon: 'Bath'}, // Bathtub
    {id: '63', icon: 'Bath'}, // Bathtub and Shower
    {id: '166', icon: 'Bath'}, // Deep Soaking Bathtub
    {id: '499', icon: 'Shower2'}, // Separate Bathtub and Shower
    {id: '337', icon: 'Clean'}, // Laundry Service (Free)
    {id: '470', icon: 'Kitchen'}, // Refrigerator
    {id: '369', icon: 'Kitchen'}, // Microwave
    {id: '540', icon: 'SofaBed'}, // Sofa Bed
    {id: '55', icon: 'Shower'}, // Bathroom
    {id: '445', icon: 'Shower'}, // Private Bathroom
    {id: '451', icon: 'Shower'}, // Private or Shared bathroom
    {id: '478', icon: 'Bed'}, // Rollaway or Extra Beds (Extra Fee)
    {id: '205', icon: 'Bed'}, // Extra Bed(s) (On Request)
    {id: '155', icon: 'Crib'}, // Crib(s)
    {id: '157', icon: 'Crib'}, // Crib(s) (Free)
    {id: '156', icon: 'Crib'}, // Crib(s) (Extra Fee)
    {id: '332', icon: 'Trampoline'}, // Laptop Workspace
    {id: '139', icon: 'CoffeeMachine'}, // Coffee Maker
    {id: '485', icon: 'Safe'}, // Safe
    {id: '319', icon: 'Safe'}, // Safety Deposit Box
    {id: '44', icon: 'Cocktail'}, // Bar
    {id: '372', icon: 'Cocktail'}, // Mini Bar
    {id: '631', icon: 'Kitchen'}, // Wet Bar
    {id: '530', icon: 'Monitor'}, // Smart TV
    {id: '601', icon: 'Monitor'}, // TV
    {id: '98', icon: 'Monitor'}, // Cable TV
    {id: '109', icon: 'Wind'}, // Ceiling Fan
    {id: '543', icon: 'SpeakerMute2'}, // Soundproofing
    {id: '26', icon: 'Wind'}, // Air Purifier
    {id: '265', icon: 'GridMasonry2'}, // Ground Floor Location
    {id: '586', icon: 'GridMasonry2'}, // Top Floor Location
    {id: '348', icon: 'GridMasonry2'}, // Located on High Floor
    {id: '194', icon: 'Elevator'} // Elevator
  ],
  // Tier 3 — unique features (Pick 2)
  [
    {id: '6', icon: 'Beach2'}, // Access to Private Beach
    {id: '447', icon: 'Beach2'}, // Private Beach Access
    {id: '454', icon: 'SwimmingPoolLadder'}, // Private Pool
    {id: '421', icon: 'Beach2'}, // Beachfront
    {id: '299', icon: 'PoolIndoor'}, // Indoor Pool
    {id: '302', icon: 'SwimmingPoolLadder'}, // Infinity Pool
    {id: '406', icon: 'SwimmingPoolLadder'}, // Outdoor pool
    {id: '431', icon: 'SwimmingPoolLadder'}, // Plunge Pool
    {id: '432', icon: 'SwimmingPoolLadder'}, // Pool
    {id: '437', icon: 'SwimmingPoolLadder'}, // Pool with View
    {id: '490', icon: 'SwimmingPoolLadder'}, // Salt Water Pool
    {id: '28', icon: 'PlaneTakeOff'}, // Airport Transfer (Free)
    {id: '453', icon: 'Parking'}, // Private Parking (Free)
    {id: '521', icon: 'Bus'}, // Shuttle (Free)
    {id: '625', icon: 'Trampoline'}, // Water Park (Free)
    {id: '449', icon: 'Trees'}, // Private Garden
    {id: '364', icon: 'SpaWellness'}, // Massage (Free)
    {id: '630', icon: 'Diamond'}, // Welcome Pack
    {id: '81', icon: 'Bicycle'}, // Bikes Available (Free)
    {id: '231', icon: 'Cocktail'}, // Welcome Drink (Free)
    {id: '7', icon: 'SwimmingPoolLadder'}, // Access to Private Pool
    {id: '448', icon: 'Door'}, // Private Entrance
    {id: '277', icon: 'SwimmingPoolLadder'}, // Heated Pool
    {id: '433', icon: 'Cocktail'}, // Pool Bar
    {id: '221', icon: 'Shower'}, // Fixed shower seat
    {id: '544', icon: 'SpaWellness'}, // Spa Access
    {id: '545', icon: 'SpaWellness'}, // Spa and Wellness (Free)
    {id: '301', icon: 'HotTub'}, // Indoor Private Spa Tub
    {id: '409', icon: 'HotTub'}, // Outdoor Private Spa Tub
    {id: '455', icon: 'HotTub'}, // Private Spa Tub
    {id: '480', icon: 'HotTub'}, // Rooftop Private Spa Tub
    {id: '546', icon: 'SpaWellness'}, // Spa Bath
    {id: '264', icon: 'Fire'}, // Fireplace
    {id: '3', icon: 'Dumbell'}, // 24h Gym
    {id: '267', icon: 'Dumbell'}, // Gym
    {id: '9', icon: 'Disability'}, // Accessible by Stairs
    {id: '215', icon: 'HotTub'}, // Hot Tub
    {id: '282', icon: 'Sauna'}, // Sauna
    {id: '450', icon: 'HotTub'}, // Private Hot Spring
    {id: '120', icon: 'Toys'}, // Children's Play Area
    {id: '271', icon: 'SpaWellness'}, // Hammam (Free)
    {id: '570', icon: 'Baseball'}, // Tennis (Free)
    {id: '537', icon: 'Anchor'}, // Snorkelling (Free)
    {id: '641', icon: 'Wind'}, // Windsurfing (Free)
    {id: '414', icon: 'Baseball'}, // Padel (Free)
    {id: '452', icon: 'Parking'}, // Private Parking (Extra Fee)
    {id: '217', icon: 'Fire'}, // Fireplace
    {id: '240', icon: 'Dice5'}, // Game Console
    {id: '200', icon: 'Bolt'}, // EV Charging Station(s)
    {id: '298', icon: 'Parking'} // Indoor Parking
  ]
]
export const RANKED_AMENITY_CATEGORIES: {
  id: string
  icon: IconName
}[] = [
  {id: '1', icon: 'Bed'}, // Bedroom
  {id: '2', icon: 'Shower'}, // Bathroom
  {id: '3', icon: 'Pin'}, // View and location
  {id: '4', icon: 'Parking'}, //Parking and transport
  {id: '5', icon: 'Wifi'}, // Internet and office
  {id: '6', icon: 'Clean'}, // Housekeeping
  {id: '7', icon: 'Restaurant'}, // Food and drinks
  {id: '8', icon: 'Toys'}, // Family
  {id: '9', icon: 'Disability'}, // Accessibility
  {id: '10', icon: 'Dice3'}, // Entertainment and sport
  {id: '11', icon: 'Trees2'}, // Outdoor
  {id: '12', icon: 'SquareCheck'} // More
]
